import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import ContentDialog, { Props as ContentDialogProps } from '@classify/react-core-components/ContentDialog';
interface Props {
  isOpen: boolean;
  shouldDisplayBack: boolean;
  onClose: ContentDialogProps['onClose'];
  children: React.ReactNode;
}
export default function Dialog(t0) {
  const $ = _c(6);
  const {
    isOpen,
    onClose,
    children,
    shouldDisplayBack
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      closeButtonLabel: translate("global.action.close_button")
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== isOpen || $[3] !== onClose || $[4] !== shouldDisplayBack) {
    t2 = <ContentDialog translations={t1} isSide={true} shouldForceDisplayBack={shouldDisplayBack} isOpen={isOpen} onClose={onClose} background="alternative">{children}</ContentDialog>;
    $[1] = children;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = shouldDisplayBack;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}